(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvet-gift-pairs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velvet-gift-pair')) {
    customElements.define('velvet-gift-pair', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.selects = [...this.querySelectorAll('select')];
        this.button = this.querySelector('button[type="submit"]');
        this.error = this.querySelector('[data-pair-error]');
        this.changeHandler = () => {
          const total = this.selects.reduce((sum, select) => sum + Number(select.selectedOptions[0]?.dataset.price || 0),0);
          this.querySelector('[data-pair-price]').textContent = new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(total / 100);
          this.button.disabled = this.selects.some(select => !select.selectedOptions[0] || select.selectedOptions[0].disabled);
        };
        this.submitHandler = async event => {
          event.preventDefault();
          if (this.button.disabled) return;
          this.button.disabled = true;
          this.button.setAttribute('aria-busy','true');
          this.error.hidden = true;
          try {
            const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:this.selects.map(select=>({id:Number(select.value),quantity:1}))})});
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.error.dataset.defaultError);
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            this.error.textContent = error.message || this.error.dataset.defaultError;
            this.error.hidden = false;
            this.button.removeAttribute('aria-busy');
            this.changeHandler();
          }
        };
        this.form.addEventListener('change',this.changeHandler);
        this.form.addEventListener('submit',this.submitHandler);
        this.changeHandler();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('change',this.changeHandler);
        this.form?.removeEventListener('submit',this.submitHandler);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
